'use strict';

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var VerticalSpace = function VerticalSpace(props) {
  return React__default["default"].createElement("div", {
    style: {
      height: props.height,
      display: 'block'
    }
  });
};

module.exports = VerticalSpace;
